import { render } from "./AlbumPicker.vue?vue&type=template&id=56b61005&scoped=true&ts=true"
import script from "./AlbumPicker.vue?vue&type=script&lang=ts"
export * from "./AlbumPicker.vue?vue&type=script&lang=ts"

import "./AlbumPicker.vue?vue&type=style&index=0&id=56b61005&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b61005"]])

export default __exports__